import React, { Component } from 'react';
import styles from './Tree.module.css';
import { restructureResponse } from '../../helpers/sparql';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHandPointLeft,
  faPercent,
  faCoffee,
  faCube,
  faCheck,
  faDrawPolygon,
  faCircle,
  faInfo,
  faSquare,
  faSquareFull,
  faPlus,
  faBox,
  faCogs,
  faDotCircle,
  faDatabase,
  faDiceD6,
  faBullseye,
  faBoxOpen,
  faCheckSquare,
  faGavel
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faCheckSquare,
  faPercent,
  faGavel,
  faHandPointLeft,
  faCheck,
  faCircle,
  faDrawPolygon,
  faInfo,
  faSquare,
  faSquareFull,
  faPlus,
  faCogs,
  faBullseye,
  faDotCircle,
  faDiceD6,
  faDatabase,
  faBox,
  faBoxOpen,
  faCube,
  faCoffee,
  faCube
);

//console.log(faHandPointLeft.iconName);

class TreeItem extends Component {
  state = {
    childrenVisible: this.props.depth < 1
  };

  determineVisibility(item) {
    if (!item.children) return;
    if (item.containsSelection) {
      this.setState({
        childrenVisible: true
      });
    } else {
      if (this.props.shouldNonSelectedSubTreeClose) {
        this.setState({
          childrenVisible: false
        });
      }
    }
  }

  componentDidMount() {
    if (!this.props.selectedItem) return;
    this.determineVisibility(this.props.item);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedItem) return;
    if (prevProps.selectedItem === this.props.selectedItem) return;
    this.determineVisibility(this.props.item);
  }

  treeItemClicked = () => {
    //console.log(this.props.item);
    this.props.treeItemClicked(this.props.item);
  };

  arrowClicked = () => {
    this.setState({
      childrenVisible: !this.state.childrenVisible
    });
  };

  renderArrow(item) {
    if (!item.children) return <span className={styles.treeArrow} />;
    if (this.state.childrenVisible) {
      return <span onClick={this.arrowClicked} className={styles.treeArrow + ' ' + styles.down} />;
    } else {
      return <span onClick={this.arrowClicked} className={styles.treeArrow + ' ' + styles.right} />;
    }
  }

  render() {
    let item = this.props.item;
    let labelKey = this.props.data.head.vars[0];
    let treeItemURIKey = this.props.data.head.vars[1];
    // sorteren doen we voorlopig even via sparql
/*
    if (item.children) {
      item.children.sort((a, b) => {
        if (!a[labelKey]) return 0;
        return a[labelKey].localeCompare(b[labelKey]);
      });
    }
    */

    if (item.icon == null) {
      if (this.props.defaultIcon != '') {
        item.icon = this.props.defaultIcon;
      }
    }

    // <FontAwesomeIcon icon="info" size="xs" transform="down-6; right-4" />
    return (
      <div className={styles.treeItem}>
        <div className={styles.treeLabel}>
          {this.renderArrow(item)}
          {item.icon != null && <FontAwesomeIcon icon={item.icon} size="xs" transform="down-6; left-4" />}
          {item.icon2 != null && <FontAwesomeIcon icon={item.icon2} size="xs" transform="down-6; left-4" />}
          {item.icon3 != null && <FontAwesomeIcon icon={item.icon3} size="xs" transform="down-6; left-4" />}

          <span
            onClick={this.treeItemClicked}
            className={this.props.selectedItem === item[treeItemURIKey] ? styles.selected : ''}>
            {item[labelKey]}
          </span>
        </div>
        {item.children &&
          this.state.childrenVisible &&
          item.children.map((item, index) => {
            return <TreeItem key={index} {...this.props} item={item} depth={this.props.depth + 1} />;
          })}
      </div>
    );
  }
}

class Tree extends Component {
  state = {
    items: []
  };

  treeItemClicked = item => {
    let treeItemURIKey = this.props.data.head.vars[1];
    let publishVariable = this.props.publishVariable;
    this.props.publish(publishVariable, item[treeItemURIKey]);
    //console.log(item[treeItemURIKey]);
  };

  containsSelection(selectedURI,treeItemURIKey,item)
  {
     if (item[treeItemURIKey]==selectedURI) {return true;}
     var b=false;
     for (var n in item.children) 
     { 
       var child=item.children[n];
       child.containsSelection = this.containsSelection(selectedURI,treeItemURIKey,child);
       if (child.containsSelection==true){b=true;}
     }
     return b;
  };

  openSelectie(items) {
    let selectedURI = this.props.pubsub[this.props.subscribeVariable];
    if (selectedURI==null){return;}
    let treeItemURIKey = this.props.data.head.vars[1];
    for (var n in items) 
    {
      var item= items[n];
      item.containsSelection = this.containsSelection(selectedURI,treeItemURIKey,item);
    }

  };

  

  findParents(ar) {
   
    let headVars = this.props.data.head.vars;
    let labelKey = headVars[0];
    let treeItemURIKey = headVars[1];
    let parentItemURIKey = headVars[2];
    let parents = [];
    let uri_items = {};
    // zoek parents en creeer uri hash
    for (var n in ar) {
      let item = ar[n];
      
      var itemsar = uri_items[item[treeItemURIKey]];
      if (itemsar == null) {
        itemsar = [];
        uri_items[item[treeItemURIKey]] = itemsar;
      }
      itemsar.push(item);
    }
    
    // zet children
    for (var n in ar) {
      var item = ar[n];
      if ( uri_items[item[parentItemURIKey]]== null) 
      {
        
        parents.push(item);
       // console.log("finding parent "+item[labelKey],parents[0]);
      }
     // console.log(parents) ;

      var parent = item[parentItemURIKey];
      if (parent != null) {
        var itemsar = uri_items[parent];
        if (itemsar != null) {
          for (var i in itemsar) {
            var parentO = itemsar[i];
            var children = parentO.children;
            if (children == null) {
              children = [];
              parentO.children = children;
            }
            children.push(item);
          }
        }
      }
    }
       
    return parents;
  }

  aggregate(items) {
    let headVars = this.props.data.head.vars;
    let treeItemURIKey = headVars[1];
    let parentItemURIKey = headVars[2];

    var id_binding = {};
    for (var n in items.results.bindings) {
      var binding = items.results.bindings[n];
      var parent = 'onbekend';
      if (binding[parentItemURIKey] != null) parent = binding[parentItemURIKey].value;
      var id = parent + '_' + binding[treeItemURIKey].value;
      var double = id_binding[id];
      if (double != null) {
        for (var key in binding) {
          double[key] = binding[key];
        }
      } else {
        id_binding[id] = binding;
      }
    }
    var result = [];
    //console.log(id_binding);
    for (var k in id_binding) result.push(id_binding[k]);

    items.results.bindings = result;
    // console.log(items);
    return items;
  }

  /*shouldComponentUpdate()
  {
    console.log("tree needs to be updated");
    return true;
  }
*/


  render() {
    if (!this.props.data) return null;
    let selectedURI = this.props.pubsub[this.props.subscribeVariable];
    let items = this.props.data;

    var item=this.createTreeItems();

    var depth=0;
    return (
      <div className={styles.main}>
        <TreeItem
          {...this.props}
          item={item}
          treeItemClicked={this.treeItemClicked}
          selectedItem={this.props.pubsub[this.props.subscribeVariable]}
          depth={depth}
        />
      </div>
    );
  }


  
  createTreeItems()
  {
    let selectedURI = this.props.pubsub[this.props.subscribeVariable];
    let items = this.props.data;
    if (this.props.aggregate) {
      items = this.aggregate(items);
    }
     items = restructureResponse(items);
    

    let headVars = this.props.data.head.vars;
    let treeItemURIKey = headVars[1];
    let parentItemURIKey = headVars[2];
   
    if (false) {
      let sortingReady = false;
      let sortLoop = function() {
        sortingReady = true;
        for (let j = 0; j < items.length; j++) {
          let parentIndex = items.findIndex(it => it[treeItemURIKey] === items[j][parentItemURIKey]);
          if (parentIndex === -1) continue;
          if (j < parentIndex) {
            let tmp = items[j];
            items[j] = items[parentIndex];
            items[parentIndex] = tmp;
            sortingReady = false;
          }
        }
      };

      if (!sortingReady) {
        sortLoop();
      }

      for (let i = items.length - 1; i >= 0; i--) {
        let item = items[i];
        if (item[treeItemURIKey] === selectedURI) {
          item.containsSelection = true;
        }

        let parent = items.find(it => {
          return it[treeItemURIKey] === item[parentItemURIKey];
        });
        if (parent) {
          parent.children = parent.children || [];
          parent.children.push(item);

          if (item.containsSelection) {
            parent.containsSelection = true;
          }
          items.splice(i, 1);
        }
      }
    } else 
    {
      items = this.findParents(items);
      this.openSelectie(items);
      //items=[];
     // console.log(items[0],items[1],items[2]) ;
    }

    let labelKey = headVars[0];
    let item = {
      [labelKey]: this.props.rootLabel,
      children: items,
      containsSelection: !!selectedURI
    };
   
    if ((this.props.rootLabel == '' || this.props.rootLabel == null) && items.length == 1) {
      item = items[0];
      // console.log("setting single data parent as root of the table",item);
    }
     return item;
  }

  
}

export default Tree;
